import jbfFeed from './jbfFeed'
import selectFeed from './selectFeed'
import jumboFeed from './jumboFeed'
import petFood from './petFood'
import rawMaterial from './rawMaterial'
import qualitySystem from './qualitySystem'
import information from './information'
import aboutUs from './aboutUs'


export default [...jbfFeed, ...selectFeed, ...jumboFeed, ...petFood, ...rawMaterial, ...qualitySystem, ...information, ...aboutUs]
